define("shared/components/shared/post/secondary/hashtag-suggestions/table", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <table class="o--table o--table--condensed o--table--sort o--table--hover u--m__b__0">
    <thead>
      <tr>
        <th class="cMH--th__title u--p__l__lg">
          <span>
            {{t "hashtag_suggestions.industry.th_1"}}
          </span>
          <span class="u--text--light u--text--sm u--p__l__xs">
            ({{t "hashtag_suggestions.hashtags_count" count=@suggestedHashtags.length}})
          </span>
        </th>
        <th class="u--p__l__xs">
          <span>
            {{t "hashtag_suggestions.search.th_2"}}
            <EmberTooltip @delay={{330}}>
              {{t "hashtag_suggestions.search.th_2_tooltip"}}
            </EmberTooltip>
          </span>
        </th>
        <th class="u--p__r__lg"></th>
      </tr>
    </thead>
    <tbody>
      {{#each @suggestedHashtags as |hashtag index|}}
        <Shared::Post::Secondary::HashtagSuggestions::Item
          @hashtag={{hashtag}}
          @selectedHashtags={{@selectedHashtags}}
          @selectHashtag={{@selectHashtag}}
          @qaClass={{if (eq index 0) "qa--first_hashtagText"}}
        />
      {{/each}}
    </tbody>
  </table>
  
  */
  {
    "id": "00kfMGhe",
    "block": "[[[10,\"table\"],[14,0,\"o--table o--table--condensed o--table--sort o--table--hover u--m__b__0\"],[12],[1,\"\\n  \"],[10,\"thead\"],[12],[1,\"\\n    \"],[10,\"tr\"],[12],[1,\"\\n      \"],[10,\"th\"],[14,0,\"cMH--th__title u--p__l__lg\"],[12],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"hashtag_suggestions.industry.th_1\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--text--light u--text--sm u--p__l__xs\"],[12],[1,\"\\n          (\"],[1,[28,[35,0],[\"hashtag_suggestions.hashtags_count\"],[[\"count\"],[[30,1,[\"length\"]]]]]],[1,\")\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"th\"],[14,0,\"u--p__l__xs\"],[12],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"hashtag_suggestions.search.th_2\"],null]],[1,\"\\n          \"],[8,[39,1],null,[[\"@delay\"],[330]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,0],[\"hashtag_suggestions.search.th_2_tooltip\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"th\"],[14,0,\"u--p__r__lg\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,1]],null]],null],null,[[[1,\"      \"],[8,[39,4],null,[[\"@hashtag\",\"@selectedHashtags\",\"@selectHashtag\",\"@qaClass\"],[[30,2],[30,4],[30,5],[52,[28,[37,6],[[30,3],0],null],\"qa--first_hashtagText\"]]],null],[1,\"\\n\"]],[2,3]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@suggestedHashtags\",\"hashtag\",\"index\",\"@selectedHashtags\",\"@selectHashtag\"],false,[\"t\",\"ember-tooltip\",\"each\",\"-track-array\",\"shared/post/secondary/hashtag-suggestions/item\",\"if\",\"eq\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/table.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});